<template>
  <div>
    <div v-if="modalApproveSuccessful" class="text-center mx-auto">
      <div class="mt-16">
        <svg
          width="174"
          height="186"
          viewBox="0 0 174 186"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="86.5116" cy="99.4882" r="86.5116" fill="#E0E0E0" />
          <g clip-path="url(#clip0)">
            <path
              d="M132.998 30.0173C132.143 29.7693 131.651 28.8751 131.899 28.0201L133.453 22.6597C134.929 17.5729 131.991 12.2343 126.904 10.759C121.817 9.28363 116.479 12.2219 115.003 17.3085C114.755 18.1637 113.861 18.6557 113.006 18.4077C112.151 18.1596 111.659 17.2657 111.907 16.4104C113.877 9.61616 121.008 5.69193 127.802 7.66248C134.596 9.63303 138.52 16.7635 136.55 23.5577L134.995 28.9181C134.747 29.7734 133.853 30.2653 132.998 30.0173Z"
              fill="#79C6E4"
            />
            <path
              d="M36.3804 162.642H136.643C140.271 162.642 143.212 159.701 143.212 156.073V32.0254C143.212 28.3974 140.271 25.4565 136.643 25.4565H36.3804C32.7524 25.4565 29.8115 28.3974 29.8115 32.0254V156.073C29.8115 159.701 32.7527 162.642 36.3804 162.642Z"
              fill="white"
            />
            <path
              d="M112.041 53.1652C106.55 51.5728 103.379 45.8103 104.972 40.3202L111.907 16.4084C112.155 15.5532 113.049 15.0612 113.904 15.3092C114.759 15.5573 115.251 16.4512 115.003 17.3065L108.068 41.218C106.971 45.001 109.156 48.9713 112.939 50.0685C116.722 51.1657 120.692 48.9806 121.789 45.1976L128.724 21.2861C129.443 18.8068 128.012 16.2051 125.532 15.486C123.053 14.767 120.451 16.1991 119.732 18.6781L115.451 33.4407C115.203 34.2959 114.308 34.7878 113.453 34.5398C112.598 34.2918 112.106 33.3978 112.354 32.5426L116.636 17.78C117.85 13.5936 122.244 11.1754 126.43 12.3896C130.617 13.6038 133.035 17.9977 131.821 22.1841L124.886 46.0957C123.293 51.5861 117.531 54.7576 112.041 53.1652Z"
              fill="#79C6E4"
            />
            <path
              d="M120.344 105.655H52.5592C51.2431 105.655 50.1768 104.589 50.1768 103.273C50.1768 101.957 51.2431 100.89 52.5592 100.89H120.344C121.66 100.89 122.726 101.957 122.726 103.273C122.726 104.588 121.66 105.655 120.344 105.655Z"
              fill="#79C6E4"
            />
            <path
              d="M96.3143 121.301H52.5592C51.2431 121.301 50.1768 120.234 50.1768 118.918C50.1768 117.602 51.2431 116.536 52.5592 116.536H96.3143C97.6301 116.536 98.6968 117.602 98.6968 118.918C98.6968 120.234 97.6301 121.301 96.3143 121.301Z"
              fill="#404B58"
            />
            <path
              d="M106.638 136.949H52.5592C51.2431 136.949 50.1768 135.883 50.1768 134.567C50.1768 133.25 51.2431 132.184 52.5592 132.184H106.638C107.954 132.184 109.021 133.25 109.021 134.567C109.021 135.882 107.954 136.949 106.638 136.949Z"
              fill="#404B58"
            />
            <path
              d="M62.4918 82.9967C61.1758 82.9967 60.1094 81.9303 60.1094 80.6142V75.9376C60.1094 74.6216 61.1758 73.5552 62.4918 73.5552C63.8079 73.5552 64.8743 74.6216 64.8743 75.9376V80.6142C64.8743 81.93 63.8082 82.9967 62.4918 82.9967Z"
              fill="#404B58"
            />
            <path
              d="M118.308 82.9967C116.992 82.9967 115.925 81.9303 115.925 80.6142V75.9376C115.925 74.6216 116.992 73.5552 118.308 73.5552C119.624 73.5552 120.69 74.6216 120.69 75.9376V80.6142C120.69 81.93 119.623 82.9967 118.308 82.9967Z"
              fill="#404B58"
            />
            <path
              d="M90.5436 86.5865C87.0084 86.5865 83.6466 85.0554 81.3203 82.3858C80.4557 81.3937 80.5592 79.8887 81.5513 79.0243C82.5436 78.1599 84.0478 78.2632 84.9127 79.2552C86.334 80.8864 88.3864 81.8216 90.5439 81.8216C92.7015 81.8216 94.7539 80.8864 96.1751 79.2552C97.0391 78.2635 98.5442 78.1599 99.5365 79.0243C100.528 79.8887 100.632 81.3937 99.7675 82.3858C97.4406 85.0551 94.0788 86.5865 90.5436 86.5865Z"
              fill="#404B58"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="162.642"
                height="162.642"
                fill="white"
                transform="translate(5.19092)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <p
        class="text-2xl my-16 border-2 rounded border-zt-success text-zt-success p-2 font-bold w-3/5 mx-auto"
      >
        {{
          $t("message.uploadImageComponent.modals.xDocumentsApproved", {
            quantity: documentsAmount,
          })
        }}
      </p>
    </div>
    <div
      class="zt-modal-footer flex justify-center lg:justify-end items-center p-4"
    >
      <zt-button
        data-vs-button="approve-successful"
        class="ml-1"
        @click="$emit('closeApproveModalAndUpdateTask')"
        >{{
          $t("message.uploadImageComponent.modals.buttonUnderstand")
        }}</zt-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    documentsAmount: {
      type: Number,
      default: 0,
    },
    modalApproveSuccessful: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped></style>
